import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const BoltIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/bolt"><path id="Icon" d="M14.3801 2.28857C14.4656 1.88948 14.2718 1.48281 13.908 1.29778C13.5442 1.11276 13.1015 1.19571 12.8293 1.49987L2.62932 12.8999C2.39265 13.1644 2.33355 13.5433 2.47843 13.8673C2.6233 14.1914 2.9451 14.4 3.30004 14.4H11.1868L9.62002 21.7114C9.5345 22.1105 9.72824 22.5172 10.092 22.7022C10.4558 22.8872 10.8986 22.8043 11.1708 22.5001L21.3708 11.1001C21.6074 10.8356 21.6665 10.4567 21.5217 10.1326C21.3768 9.80861 21.055 9.59999 20.7 9.59999H12.8133L14.3801 2.28857Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default BoltIcon;